import React, { useState, useEffect } from 'react';
import Table from './components/Table/Table';
import { getAllTerminalsByLocalId, deleteTerminal } from '../../../../crud/management_api/terminals';
import { Terminals } from '../types';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { getWorkstationsOptions, WorkstationOption, getTerminal_TypesOption, Terminal_TypesOption } from './components/utils/utils';
import FilterBar from './components/FilterBar/FilterBar';
import { MPPageTitle } from '../../../../components/ui';
import { toast } from 'react-toastify';
import { getPermissionState } from '../../../../utils/functions';


const Terminal: React.FC = () => {
    const [terminals, setTerminals] = useState<Terminals[]>([]);
    const [loading, setLoading] = useState(true);
    const [filteredTerminals, setFilteredTerminals] = useState<Terminals[]>([]);
    const [workstations, setWorkstations] = useState<WorkstationOption[]>([]);
    const [terminalTypes, setTerminalTypes] = useState<Terminal_TypesOption[]>([]);
    const [searchValue, setSearchValue] = useState('');
    const [showSelection, setShowSelection] = useState(false);
    const [selectedTerminals, setSelectedTerminals] = useState<string[]>([]);
    const [showCreateModal, setShowCreateModal] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
          const fetchedWorkstations = await getWorkstationsOptions();
          
          setWorkstations(fetchedWorkstations);
        };
        
        fetchData();
      }, []);

      useEffect(() => {
        const fetchData = async () => {
          const fetchedTerminalTypes = await getTerminal_TypesOption();
          
          setTerminalTypes(fetchedTerminalTypes);
        };
        
        fetchData();
      }, []);

      useEffect(() => {
        const userContext = localStorage.getItem('user');
        const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
        getAllTerminalsByLocalId(localId)
          .then(response => {
            setTerminals(response.data);
            setFilteredTerminals(response.data);
            setLoading(false);
          })
          .catch(error => {
            console.error("Error fetching Terminals:", error);
            setLoading(false);
          });
      }, []);

      useEffect(() => {
        if (searchValue.trim() === '') {
          setFilteredTerminals(terminals);
        } else {
          const filtered = terminals.filter(terminal =>
            terminal.terminal_name.toLowerCase().includes(searchValue.toLowerCase())
          );
          setFilteredTerminals(filtered);
        }
      }, [searchValue, terminals]);

      const handleDeleteSelection = async () => {
        if (!selectedTerminals.length) {
          toast.error('Selecciona al menos un dispositivo');
          return;
        }
        try {
          await Promise.all(selectedTerminals.map(id => deleteTerminal(Number(id))));
          const newTerminals = terminals.filter(t => !selectedTerminals.includes(t.terminal_id));
          setTerminals(newTerminals);
          setFilteredTerminals(newTerminals);
          setSelectedTerminals([]);
          setShowSelection(false);
          toast.success('Dispositivos eliminados');
        } catch {
          toast.error('Error al eliminar dispositivos');
        }
      };

      const handleSelectionToggle = () => {
        if (showSelection) {
          setSelectedTerminals([]);
        }
        setShowSelection(!showSelection);
      };

      if (loading) {
        return <LoadingSpinner text="Cargando dispositivos" transparent={true} />;
      }

      return (
        <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
          <MPPageTitle>Impresoras y dispositivos</MPPageTitle>

          <FilterBar
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            showSelection={showSelection}
            selectedCount={selectedTerminals.length}
            onCreateClick={() => setShowCreateModal(true)}
            onSelectionToggle={handleSelectionToggle}
            onDeleteSelection={handleDeleteSelection}
            canCreate={getPermissionState(44)}
          />
          <Table 
            terminals={filteredTerminals} 
            workstations={workstations} 
            terminalTypes={terminalTypes}
            externalShowSelection={showSelection}
            externalSelectedTerminals={selectedTerminals}
            externalSetSelectedTerminals={setSelectedTerminals}
            externalShowCreateModal={showCreateModal}
            externalSetShowCreateModal={setShowCreateModal}
          />
        </div>
      );

};
export default Terminal;